import type { DocMigration } from "../docMigration";

function isOpenDoorType(doorType: string): boolean {
  switch (doorType) {
    case "ARC":
    case "PORTICO":
    case "OPEN":
      return true;
  }
  if (isLegacyArchedDoor(doorType)) {
    return true;
  }
  return false;
}

function isLegacyArchedDoor(doorType: string): boolean {
  if (!doorType) {
    return false;
  }
  if (doorType.match(/^EXT_SGL_(PORTICO|ARC)/)) {
    return true;
  }
  return false;
}

function isFullArch(headCasingType: string): boolean {
  return headCasingType === "FULL_ARCH";
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_342: DocMigration = {
  maxSchemaVersion: "0.0.342",
  description: "Ensures that opening openings have no trim by default.",
  apply(json: any) {
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "DOOR_CATALOG_SETTINGS") {
        if (!setting.doorTypes) {
          continue;
        }
        for (const doorId in setting.doorTypes) {
          const door = setting.doorTypes[doorId];
          if (!isOpenDoorType(door.operationType)) {
            continue;
          }
          json.settings[settingId].doorTypes[doorId] = {
            ...door,
            exteriorCasing: {
              ...door.exteriorCasing,
              sideCasingType: "DISABLED",
              apronCasingType: "DISABLED",
              removeCorner: true,
            },
          };
        }
      }
    }
    for (const openingId in json.openings) {
      const opening = json.openings[openingId];
      if (opening.type !== "DOOR" && opening.type !== "DOOR_V2") {
        continue;
      }
      if (!isOpenDoorType(opening.doorType)) {
        continue;
      }
      json.openings[openingId] = {
        ...opening,
        exteriorCasing: {
          ...opening.exteriorCasing,
          casingHorizontalOffset:
            isLegacyArchedDoor(opening.doorType) && isFullArch(opening.exteriorCasing?.headCasingType) ? -2 : 0,
          sideCasingType: "DISABLED",
          apronCasingType: "DISABLED",
          removeCorner: true,
        },
      };
    }

    return json;
  },
};

export default migration_0_0_342;
